// extracted by mini-css-extract-plugin
export default {"gameIFrame":"GameIFrame__gameIFrame--3-2"};